export const SCHEDULES_PART01 = [
  {
    id: 'demo-sch-inbox-brief',
    title: 'Morning inbox brief',
    cron: '0 8 * * 1-5',
    enabled: true,
    apps: ['Gmail', 'Google Calendar'],
    goal:
      'Summarise unread email from the last 24 hours that needs a reply or a decision, flag anything from customers or leadership, and list today’s meetings with a one-line prep note for each.',
  },
  {
    id: 'demo-sch-pipeline',
    title: 'Weekly pipeline review',
    cron: '0 9 * * 1',
    enabled: true,
    apps: ['HubSpot', 'Slack'],
    goal:
      'Review open HubSpot deals: what moved stage, what slipped its close date, and what has had no activity for 14 days. Post the summary with owners and amounts to #sales.',
  },
  {
    id: 'demo-sch-trademark-watch',
    title: 'IP-India trademark journal watch',
    cron: '0 10 * * 1',
    enabled: true,
    apps: ['Web research'],
    goal:
      'Download this week’s IP-India trademark journal, compare newly advertised marks against our watchlist (DataObserve, DO Chat, DO Sense), and flag anything confusingly similar with its application number and opposition deadline.',
  },
]
